import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { getPaymentStatus, getPayPalStatus } from '../lib/api';

export default function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const paypalOrder = params.get('paypal_order');
  const [status, setStatus] = useState('checking');
  const [lookup, setLookup] = useState('');

  useEffect(() => {
    let attempts = 0;
    const poll = async () => {
      try {
        if (paypalOrder) {
          const { data } = await getPayPalStatus(paypalOrder);
          if (data.payment_status === 'paid') { setLookup(data.lookup_key || ''); setStatus('paid'); return; }
        } else if (sessionId) {
          const { data } = await getPaymentStatus(sessionId);
          if (data.payment_status === 'paid') { setLookup(data.lookup_key || ''); setStatus('paid'); return; }
        } else { setStatus('error'); return; }
      } catch (e) { /* keep polling */ }
      attempts += 1;
      if (attempts < 20) setTimeout(poll, 2500);
      else setStatus('pending');
    };
    poll();
  }, [sessionId, paypalOrder]);

  return (
    <main className="min-h-screen flex items-center justify-center px-4 pt-16" data-testid="payment-success-page">
      <div className="max-w-lg w-full rounded-xl border border-slate-700/70 bg-[#1E293B] p-10 text-center">
        {status === 'paid' ? (
          <>
            <CheckCircle2 className="w-16 h-16 mx-auto text-green-400" />
            <h1 className="mt-6 font-display text-4xl text-white" data-testid="payment-success-title">
              {t('payment.successTitle')}
            </h1>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed" data-testid="payment-success-text">
              {lookup.startsWith('training_') ? t('payment.successTextTraining') : lookup.startsWith('selection_') ? t('payment.successTextSelection') : t('payment.successText')}
            </p>
          </>
        ) : (
          <>
            <Loader2 className="w-14 h-14 mx-auto text-blue-400 animate-spin" />
            <h1 className="mt-6 font-display text-3xl text-white" data-testid="payment-checking-title">
              {t('payment.checking')}
            </h1>
            <p className="mt-4 text-sm text-slate-400">{t('payment.pendingText')}</p>
          </>
        )}
        <Link
          data-testid="payment-back-home"
          to="/"
          className="mt-8 inline-flex items-center gap-2 rounded-lg border border-slate-600 px-6 py-3 text-base font-semibold text-slate-100 transition-colors hover:border-blue-500/60 hover:text-blue-300"
        >
          {t('payment.backHome')}
        </Link>
      </div>
    </main>
  );
}
